import Regex from '../Regex'

export default class AlphaUpper extends Regex {
  get ruleName () {
    return 'alphaUpper'
  }

  passes () {
    return super.passes(/^[A-ZÀ-Ý]+$/)
  }
}
